<template>
  <div class="app-page">
    <PageHeader type="back" :backFun="goBack" />
    <section class="page-panel">
      <!-- <p>{{cycle}}</p> -->
      <p class="season">
        <span class="tl-item-title">{{ $t('user.Application Season') }}：</span>
        <span class="tl-item-content">{{ season }}</span>
      </p>
      <template v-if="cycle?.offline_mode == 0">
        <a-timeline>
          <a-timeline-item>
            <span class="tl-item-title">{{ $t('user.Current Role') }}：</span>
            <span class="tl-item-content">
              {{ currentRole }}
            </span>
          </a-timeline-item>
          <a-timeline-item>
            <span class="tl-item-title">{{ $t('user.Target Role') }}：</span>
            <span class="tl-item-content">
              {{ targetRole }}
            </span>
          </a-timeline-item>
        </a-timeline>
      </template>
      <a-table
        v-if="panelResult.result"
        class="panel-result-table"
        :columns="[
          {
            title: $t('user.Panel Result'),
            key: 'result',
            width: '30%',
            dataIndex: 'result',
          },
          {
            title: $t('user.Panel Comments'),
            key: 'comments',
            dataIndex: 'comments',
          },
        ]"
        :data-source="[panelResult]"
        :pagination="false"
      >
        <template v-slot:emptyText>
          <Empty />
        </template>
      </a-table>
      <a-empty v-else-if="cycle?.offline_mode == 0" description="结果尚未发布" />
      <p class="highlight" v-if="cycle?.offline_mode == 0">*{{ $t('user.The highlighted items show the key difference between this level and one level down.') }}</p>
    </section>
    <div class="application-page-container" v-if="cycle?.offline_mode == 0">
      <div class="info-left">
        <ApplyTable v-model:data="jobQualifications" :status="0" />

        <div class="btn-groups">
          <router-link :to="{ path: '/me/application' }">
            <a-button class="btn-back" type="primary">
              {{ $t('user.Back') }}
            </a-button>
          </router-link>
        </div>
      </div>

      <div class="info-right">
        <div class="jinfo-list">
          <div class="jinfo-list-top">
            <div class="jinfo-header">
              <div class="jinfo-title">{{ $t('user.Learning') }}</div>
            </div>
            <div>
              <div class="jinfo-sub-header">
                <div class="jinfo-title">{{ $t('user.Mandatory') }}</div>
              </div>
              <div v-for="(doc, index) in docs" :key="index" class="jinfo-content">
                <CheckOutlined style="color: #ac7f40; font-size: 18px" v-if="doc.checked" />
                <CloseOutlined style="color: #f44336; font-size: 18px" v-else />
                <p
                  :class="{
                    'jinfo-text': true,
                    'doc-highlight': doc.type == 'doc_highlight',
                  }"
                >
                  {{ doc.f }}
                </p>
              </div>
              <!-- <div
              :class="`jinfo-content ${
                jobInfo.resources == null ? 'default' : 'list'
              }`"
              v-html="
                jobInfo.resources ||
                'Please select role to see learning resources.'
              "
            ></div> -->
              <div class="jinfo-sub-header" v-if="docs_optional.length > 0">
                <div class="jinfo-title">{{ $t('user.Optional') }}</div>
              </div>
              <div v-for="(doc, index) in docs_optional" :key="index" class="jinfo-content">
                <CheckOutlined style="color: #ac7f40; font-size: 18px" v-if="doc.checked" />
                <CloseOutlined style="color: #f44336; font-size: 18px" v-else />
                <p
                  :class="{
                    'jinfo-text': true,
                    'doc-highlight': doc.type == 'doc_highlight',
                  }"
                >
                  {{ doc.f }}
                </p>
              </div>
            </div>
          </div>
          <div class="jinfo-list-bottom">
            <div class="jinfo-footer">
              <div class="jinfo-comment">
                <label class="jinfo-title">{{ $t('user.Employee') }}</label>
                <div class="jinfo-content comments">
                  <a-popover v-model:visible="commentsViewPopoverVisible" placement="bottom" v-if="comment != null && comment != ''">
                    <template #content>
                      <div class="comments-view-popover">
                        <div class="comments-view-text">{{ comment }}</div>
                      </div>
                    </template>
                    <a-button type="link">
                      <svg-icon color="#ac7f40" icon-class="search-view"></svg-icon>
                      <span>&nbsp;{{ $t('user.View Comments') }}</span>
                    </a-button>
                  </a-popover>
                  <div v-else>{{ $t('user.No Comments') }}</div>
                </div>
              </div>
              <div class="jinfo-comment">
                <label class="jinfo-title">
                  {{ $t('user.Review Manager') }}
                </label>
                <div class="jinfo-content comments">
                  <a-popover v-model:visible="commentsLMViewPopoverVisible" placement="bottom" v-if="lm_comment != null && lm_comment != ''">
                    <template #content>
                      <div class="comments-view-popover">
                        <div class="comments-view-text">{{ lm_comment }}</div>
                      </div>
                    </template>
                    <a-button type="link">
                      <svg-icon color="#ac7f40" icon-class="search-view"></svg-icon>
                      <span>&nbsp;{{ $t('user.View Comments') }}</span>
                    </a-button>
                  </a-popover>
                  <div v-else>{{ $t('user.No Comments') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 线下模式的返回按钮 -->
    <div class="application-page-container" v-if="cycle?.offline_mode == 1">
      <div class="btn-groups">
        <router-link :to="{ path: '/me/application' }">
          <a-button class="btn-back" type="primary">
            {{ $t('user.Back') }}
          </a-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { getApplicationDetail } from '@/api/index'
  import ApplyTable from '@/components/ApplyTable'
  import PageHeader from '@/components/PageHeader.vue'
  import { CheckOutlined, CloseOutlined } from '@ant-design/icons-vue'
  import Empty from '@/components/Empty'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Index',
    components: { PageHeader, ApplyTable, CheckOutlined, CloseOutlined, Empty },
    data() {
      return {
        commentsViewPopoverVisible: false,
        commentsLMViewPopoverVisible: false,
        currentRole: null,
        targetRole: null,
        panelResult: {},
        jobQualifications: [],

        applicationRecord: [],
        season: null,
        current_guide: {},
        comment: null,
        lm_comment: null,
        cycle: null,
      }
    },
    computed: {
      docs() {
        const records = this.current_guide.records
        if (records) {
          return (
            this.current_guide.docs
              ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
              .map((el) => {
                el.checked = records.indexOf(el.f.toLowerCase()) != -1
                return el
              }) || []
          )
        }
        return (
          this.current_guide.docs
            ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
            .map((el) => {
              el.checked = false
              return el
            }) || []
        )
      },
      docs_optional() {
        const records = this.current_guide.records
        if (records) {
          return (
            this.current_guide.docs_optional
              ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
              .map((el) => {
                el.checked = records.indexOf(el.f.toLowerCase()) != -1
                return el
              }) || []
          )
        }
        return (
          this.current_guide.docs_optional
            ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
            .map((el) => {
              el.checked = false
              return el
            }) || []
        )
      },
    },
    mounted() {
      const aId = this.$route.params.id
      if (aId) {
        getApplicationDetail(aId).then((res) => {
          if (res.code == 200) {
            const { current, lm_comments, target, PanelComments, PanelResult, season, comment, lm_comment, cycle } = res.data

            this.cycle = cycle
            this.currentRole = current
            this.season = season
            this.currentRoleTheme = res.data.current_theme
            this.targetRole = target
            this.targetRoleTheme = res.data.target_theme
            this.panelResult = {
              result: PanelResult,
              comments: PanelComments,
            }
            this.current_guide = res.data.current_guide
            this.comment = comment
            this.lm_comment = lm_comment
            const tableData = {}
            res.data.items?.forEach((item) => {
              tableData[item.key] = {
                id: item.key,
                content: item.value,
                style: item.style,
              }
            })
            res.data.self_comments?.forEach((item, index) => {
              if (tableData[index] != null) {
                tableData[index].e_qualified = item.check
                tableData[index].e_comments = item.comments
              }
            })
            res.data.lm_comments?.forEach((item, index) => {
              if (tableData[index] != null) {
                tableData[index].t_qualified = item.check
                tableData[index].t_comments = item.comments
              }
            })
            this.jobQualifications = Object.keys(tableData).map((key) => {
              return { ...tableData[key] }
            })
          }
        })
      } else {
        this.$router.back()
      }
    },
    methods: {
      goBack() {
        this.$router.push('/')
      },
    },
  }
</script>

<style lang="less" scoped>
  @import url('@/styles/params.less');
  .application-page-container {
    margin: @app-conetent-margin;
    // background-color: #fff;
    display: flex;

    .info-left {
      padding: 24px;
      background-color: white;
      flex-grow: 7;
      width: 70%;
      margin-right: 16px;
      .btn-back {
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        line-height: 22px;
        font-weight: bold;
        padding: 0 30px;
        margin-top: 24px;
      }
    }
    .info-right {
      background-color: white;
      flex-grow: 3;
      width: 30%;
      position: relative;
    }
    .jinfo-header {
      padding: 16px 24px;
      border-bottom: 1px solid #e9e9e9;
      .jinfo-title {
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        font-weight: 700;
      }
      &.msg {
        margin: 0 24px;
        background-color: #d7c7c7;
      }
    }

    .jinfo-list {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .jinfo-comment {
      display: flex;
      align-items: center;
      padding: 0px 24px 8px 24px;

      label {
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        font-weight: 700;
        &::after {
          content: ':';
          margin: 0 8px 0 2px;
          position: relative;
          top: -0.5px;
        }
      }
    }

    .jinfo-footer {
      padding: 16px 24px;
      // padding-bottom: 14px;
      // position: absolute;
      // bottom: 0;
    }

    .jinfo-sub-header {
      padding: 16px 24px;
      .jinfo-title {
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        font-weight: 700;
      }
      &.msg {
        margin: 0 24px;
        background-color: #fafafa;
      }
    }

    .jinfo-content {
      padding: 0px 24px;
      white-space: pre-line;
      display: flex;
      .jinfo-text {
        position: relative;
        top: -3px;
        padding-left: 10px;
      }

      .doc-highlight {
        color: @primary-color;
      }
      &.list {
        padding: 16px 24px;
      }
      &.default {
        padding: 14px 24px;
      }

      &.comments {
        padding: 0;
      }
    }
  }
  .page-panel {
    margin: @app-conetent-margin;
    background-color: #fff;
    padding: 16px 24px;

    .season {
      padding-bottom: 10px;
    }

    .highlight {
      padding-top: 10px;
    }
  }
  .panel-result-table {
    margin-bottom: 0px;
  }
  .tl-item-title {
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    font-weight: bold;
  }
  .tl-item-content {
    font-size: 16px;
    color: #333333;
    line-height: 24px;
  }

  .ant-table-cell {
    text-align: left;
  }
  .application-page-container {
    .btn-groups {
      .btn-back {
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        line-height: 22px;
        font-weight: bold;
        padding: 0 30px;
      }
    }
  }
  .panel-result-table td {
    word-break: break-word;
  }
</style>
